export const channelData = [
    {
        name:"Contact",
        text: "Contact",
        image: '/images/contact-preview.gif',
        video:'/videos/contact-preview-new.mp4',

        path: '/contact',
        prev:'/',
        next:'/bis-blue',

        status: 'active',
    },
    {
        name:"Bis Blue",
        text: "",
        image: '/images/bis-blue-preview.gif',
        video: '/videos/bis-blue-preview-new.mp4',

        path: '/bis-blue',
        prev:'/contact',
        next:'/jammming',

        status: 'active',

        buttonText: "Visit Site",
        buttonPath: 'https://bisblue.com',
    },
    {
        name:"Spotify",
        text: "",
        image: '/images/credits-preview.gif',
        video: '/videos/spotify-preview.mp4',

        path: '/jammming',
        prev:'/bis-blue',
        next:'/exedra',

        status: 'active',

        buttonText: "Contact",
        buttonPath: '/contact',
    },
    {
        name: "Exedra",
        text: "",
        image: '/images/exedra-preview.png',
        video: '/videos/exedra-preview-new.mp4',

        path: '/exedra',
        prev:'/jammming',
        next:'/credits',

        status: 'active',

        buttonText: "Visit Site",
        buttonPath: 'https://exedra.app',
    },
        {
        name:"Credits",
        text: "",
        image: '',
        video: '/videos/credits-preview-mobile.mp4',

        path: '/credits',
        prev:'/exedra',
        next:'/promo',

        status: 'active',

        buttonText: "Contact",
        buttonPath: '/contact',
    },
    // {
    //     name: "Game",
    //     text: "Game",
    //     image: '/images/game-preview.webp',

    //     path: '/game',
    //     prev: '/jammming',
    //     next:'/credits',

    //     status: 'active',

    //     buttonText: "Stay Tuned!",
    //     buttonPath: '/',
    // },
    // {
    //     name: "Weather",
    //     text: "Weather",
    //     video: '/videos/tv-static.mp4',

    //     path: '/weather',
    //     prev: '/credits',
    //     next: '/',

    //     status: 'active',

    //     buttonText: "Home",
    //     buttonPath: '/'
    // },
    {
        video: '/videos/tv-static.mp4',
        path: '/',

        status: 'inactive',
    },
        {
        video: '/videos/tv-static.mp4',
        path: '/',

        status: 'inactive',
    },
    {
        video: '/videos/tv-static.mp4',
        path: '/',

        status: 'inactive',
    },
    {
        video: '/videos/tv-static.mp4',
        path: '/',

        status: 'inactive',
    },
    {
        video: '/videos/tv-static.mp4',
        path: '/',

        status: 'inactive',
    },
    {
        video: '/videos/tv-static.mp4',
        path: '/',

        status: 'inactive',
    },
    {
        name:"Your Name Here!",
        text: "",
        image: '/images/promo-preview.gif',
        video: '/videos/promo-preview-new.mp4',

        path: '/promo',
        prev: '/credits',
        next:'/',

        status: 'active',

        buttonText: "Contact",
        buttonPath: '/contact',
    },
]